import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faKey } from '@fortawesome/free-solid-svg-icons';
import { CadastrosEmpresaProps, Empresa } from './types';
import EmpresaModal from '../../../components/Cadastros/Empresas/EmpresaModal';
import ChavesModal from '../../../components/Cadastros/Empresas/ChavesModal';
import * as S from './styles';
import Table from '../../../components/interface/Tabela';

/**
 * A API devolve "2026-08-25 15:53:03". O `T` no lugar do espaco e o que torna a
 * string parseavel de forma confiavel em todos os navegadores -- com espaco, o
 * comportamento nao e garantido pela especificacao.
 */
const formatarDataHora = (valor: string | null): string => {
  if (!valor) return '';

  const data = new Date(valor.replace(' ', 'T'));
  if (isNaN(data.getTime())) return valor;

  // toLocaleString devolve "25/08/2026, 15:53:03" -- a virgula fica ruim numa
  // coluna estreita, entao data e hora sao formatadas separadamente
  return (
    data.toLocaleDateString('pt-BR') +
    ' ' +
    data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  );
};

const CadastrosEmpresa: React.FC<CadastrosEmpresaProps> = ({
  empresas,
  error,
  formData,
  isModalOpen,
  isChavesModalOpen,
  empresaSelecionada,
  chaves,
  chaveGerada,
  propagar,
  setPropagar,
  handleOpenModal,
  handleCloseModal,
  handleOpenChaves,
  handleCloseChaves,
  handleSubmit,
  handleChange,
  handleGerarChave,
  handleRevogarChave,
  handlePropagarChave,
}) => {
  return (
    <S.Container>
      {error && <S.ErrorMessage>{error}</S.ErrorMessage>}

      <S.HeaderContainer>
        <S.Aviso>
          Cada empresa aponta para o ERP do seu cliente. Sem URL e banco
          preenchidos, o app do entregador não sincroniza as notas do dia.
        </S.Aviso>
        <S.AddButton onClick={() => handleOpenModal()} title="Nova empresa">
          <FontAwesomeIcon icon={faPlus} />
        </S.AddButton>
      </S.HeaderContainer>

      <Table
        data={empresas}
        columns={[
          { key: 'identificador', header: 'Identificador', filterable: true },
          { key: 'nome', header: 'Nome', filterable: true },
          {
            key: 'url_erp',
            header: 'API do ERP',
            td: (empresa: Empresa) =>
              empresa.url_erp ? (
                <S.Mono>{empresa.url_erp}</S.Mono>
              ) : (
                <S.Badge $tom="alerta">não configurada</S.Badge>
              ),
          },
          {
            key: 'token_erp',
            header: 'Chave p/ consultar o ERP',
            td: (empresa: Empresa) => (
              <>
                <S.Mono>{empresa.token_erp || '—'}</S.Mono>{' '}
                {empresa.token_origem === 'empresa' && (
                  <S.Badge $tom="neutro">própria</S.Badge>
                )}
              </>
            ),
          },
          {
            key: 'ultima_sincronizacao',
            header: 'Última sincronização',
            td: (empresa: Empresa) =>
              empresa.ultima_sincronizacao ? (
                <S.Mono>{formatarDataHora(empresa.ultima_sincronizacao)}</S.Mono>
              ) : (
                <S.Badge $tom="neutro">nunca</S.Badge>
              ),
          },
          {
            key: 'ativo',
            header: 'Situação',
            td: (empresa: Empresa) =>
              empresa.ativo ? (
                <S.Badge $tom="ok">ativa</S.Badge>
              ) : (
                <S.Badge $tom="neutro">inativa</S.Badge>
              ),
          },
          {
            key: 'actions',
            header: 'Ações',
            width: '110px',
            td: (empresa: Empresa) => (
              <>
                <S.TableButton
                  onClick={() => handleOpenModal(empresa)}
                  title="Editar empresa"
                >
                  <FontAwesomeIcon icon={faPen} />
                </S.TableButton>
                <S.TableButton
                  onClick={() => handleOpenChaves(empresa)}
                  title="Chaves de acesso"
                >
                  <FontAwesomeIcon icon={faKey} />
                </S.TableButton>
              </>
            ),
          },
        ]}
        exportable={true}
      />

      <EmpresaModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />

      <ChavesModal
        isOpen={isChavesModalOpen}
        onClose={handleCloseChaves}
        empresa={empresaSelecionada}
        chaves={chaves}
        chaveGerada={chaveGerada}
        propagar={propagar}
        setPropagar={setPropagar}
        handleGerarChave={handleGerarChave}
        handleRevogarChave={handleRevogarChave}
        handlePropagarChave={handlePropagarChave}
      />
    </S.Container>
  );
};

export default CadastrosEmpresa;
